/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { withFocusable } from '@noriginmedia/react-spatial-navigation';
import ScrollView from '../../ScrollView';

function MiniEpgChannelsContainer({
  className,
  style,
  scrollableStyle,
  onScroll,
  children,
  resetScrollPosition,
}) {
  return (
    <ScrollView
      className={`dtv-html5-c-mini-epg__channels-container ${className}`}
      onScroll={onScroll}
      scrollableStyle={scrollableStyle}
      resetScrollPosition={resetScrollPosition}
      style={style}
    >
      {children}
    </ScrollView>
  );
}

MiniEpgChannelsContainer.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({}),
  scrollableStyle: PropTypes.shape({}),
  onScroll: PropTypes.func,
  children: PropTypes.node.isRequired,
  resetScrollPosition: PropTypes.bool,
};

MiniEpgChannelsContainer.defaultProps = {
  className: '',
  style: undefined,
  scrollableStyle: undefined,
  onScroll: undefined,
  resetScrollPosition: false,
};

export default memo(withFocusable()(memo(MiniEpgChannelsContainer)));
